import React, { Component } from "react";
import { BaseComponent } from "BaseComponent";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import {
  addScheduleTrack,
  openTrackModal,
  updateScheduleTrack,
} from "ContentActions";
import { isEmpty } from "BaseFunctions";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE, maxLengthObjectFc } from "Constants";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
class AddTrack extends BaseComponent {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.state = { loading: false };
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);

    if (this.props.session.eventid == 1759600095065910) {
      MAXLENOBJ.trackname = 60;
    }
  }

  open() {
    this.props.openTrackModal(true);
  }

  close() {
    this.props.openTrackModal(false);
  }

  onFormSubmit(values) {
    values.trackname = values.trackname.trim();
    var data = {
      ...values,
      scheduledateid: this.props.selectedScheduleDate.scheduledateid,
    };

    this.setState({ loading: true });

    if (!this.props.toEdit) {
      this.props.addScheduleTrack(data, this.props.session, (response) => {
        this.setState({ loading: false });

        if (response.error) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.reset();
          this.close();
          this.props.showSuccess(LocaleStrings.schedule_track_added);
        }
      });
    } else {
      this.props.updateScheduleTrack(data, this.props.session, (response) => {
        this.setState({ loading: false });

        if (response.error) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.reset();
          this.close();
          this.props.showSuccess(LocaleStrings.schedule_track_updated);
        }
      });
    }
  }

  renderFieldText(field) {
    let charactersLeft = "";
    if (field.maxlength) {
      charactersLeft = field.maxlength - field.input.value.length;
    }
    return (
      <div className="form-group" style={{ position: "relative" }}>
        <label>{field.label}</label>
        <input
          className="form-control"
          type={field.type}
          placeholder={field.placeholder}
          {...field.input}
          maxLength={field.maxlength ? field.maxlength : ""}
        />
        {field.maxlength ? (
          <span className="char-left">
            {field.input.value.length}
            {" / "}
            {field.maxlength}
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }

  render() {
    var { handleSubmit, invalid, pristine, submitting, toEdit } = this.props;
    var edit = toEdit;

    return (
      <div>
        <Button
          bsStyle=""
          className="btn-custom-blue schedule-add-button"
          onClick={this.open.bind(this)}
        >
          <img
            style={{ paddingRight: 10 }}
            src="../../style/images/header-icons/plus.png"
          ></img>
          {LocaleStrings.schedule_text_addtracks}
        </Button>
        <div>
          <Modal
            className="modal-container"
            show={this.props.showModal === true ? true : false}
            onHide={this.close}
            animation={true}
            keyboard={false}
            backdrop="static"
            dialogClassName="trackModal"
          >
            <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
              <Modal.Header>
                <div className="import-modal-title">{`${
                  edit ? `Edit` : `Add`
                } Schedule Track`}</div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.close()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              <Modal.Body>
                <Field
                  name="trackname"
                  label={LocaleStrings.schedule_track_form_label_name}
                  placeholder={LocaleStrings.schedule_track_form_ph_name}
                  type="text"
                  component={this.renderFieldText}
                  maxlength={MAXLENOBJ.trackname ? MAXLENOBJ.trackname : ""}
                />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  bsStyle=""
                  className="btn btn-custom-white"
                  onClick={this.close}
                >
                  {LocaleStrings.button_close}
                </Button>
                <Button
                  bsStyle=""
                  className="btn btn-custom-blue ml-10"
                  loading={this.state.loading}
                  type="submit"
                  disabled={pristine || invalid || submitting}
                >
                  {LocaleStrings.button_save}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var toEdit = !isEmpty(state.trackModal.track);
  var values = { trackname: "" };
  if (toEdit) values = state.trackModal.track;
  return {
    session: state.session,
    showModal: state.trackModal.status,
    toEdit,
    initialValues: values,
    selectedScheduleDate: state.selectedScheduleDate,
  };
}

function validate(values) {
  var errors = {};
  var trackname = values.trackname;
  if (trackname && trackname.trim() === "") {
    errors.trackname = "Please input Track name!";
  }

  // if(values.trackname && values.trackname.length>15){
  //   errors.trackname = "Track name can't exceed 15 characters!";
  // }

  if (values["trackname"] && MAXLENOBJ) {
    if (values["trackname"].length > MAXLENOBJ.trackname) {
      errors["trackname"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.trackname;
    }
  }

  return errors;
}

export default connect(mapStateToProps, {
  addScheduleTrack,
  openTrackModal,
  updateScheduleTrack,
  showError,
  showSuccess,
})(
  reduxForm({
    form: "AddTrackForm",
    validate,
    enableReinitialize: true,
  })(AddTrack)
);
